const defaultSlippage = 0.005;
export function getDepositSlippage() {
    return getTradeSlippage();
}
export function getTradeSlippage() {
    try {
        const lsSlippage = window.localStorage.getItem('slippage');
        return lsSlippage || defaultSlippage;
    }
    catch (e) {
        return defaultSlippage;
    }
}
//# sourceMappingURL=slippage.js.map